module.exports = __webpack_public_path__ + "img/content_pic01.571774ca.jpg";